export default "__VITE_ASSET__C8z5_2XZ__"